import { Field as ChakraField } from "@chakra-ui/react";
import { forwardRef } from "react";

export const Field = forwardRef(
  /**
   * @typedef {object} Props
   * @prop {string} [label]
   * @prop {import("react").ReactNode} children
   * @prop {string} [helperText]
   * @prop {string} [errorText]
   * @prop {string} [optionalText]
   */
  /**
   * @param {Props & ChakraField.RootProps} props
   */
  function Field(props, ref) {
    const { label, children, helperText, errorText, optionalText, ...rest } =
      props;
    return (
      <ChakraField.Root ref={ref} {...rest}>
        {label && (
          <ChakraField.Label>
            {label}

            <ChakraField.RequiredIndicator fallback={optionalText} />
          </ChakraField.Label>
        )}

        {children}

        {helperText && (
          <ChakraField.HelperText>{helperText}</ChakraField.HelperText>
        )}

        {errorText && (
          <ChakraField.ErrorText>{errorText}</ChakraField.ErrorText>
        )}
      </ChakraField.Root>
    );
  },
);
